import {registerRoute, registerMenuItem, registerReducer} from 'bloom';
import LP from 'modules/app/helpers/lp';
import GuidesReducer from './reducers/guidesReducer';
import GuideElementContainer from './containers/guideElementContainer'; 

registerReducer('guides', GuidesReducer);

export { GuideElementContainer as GuideElement };